import React from 'react';
import styles from '../css/Main.css';

export default function Arbeiten(props) {
  return (
    <div>
      {props.children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Arbeiten.js